import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import { FormikField } from '../../../../components/FormikField';
import { dataFieldsinitialValues } from '../../config/initialValues';
import { dataFieldFormConfig } from './formConfig';
import styles from './DataFieldsDialog.styles.scss';
import cn from 'classnames';

const DataFieldsDialog = ({
  initialValues,
  isOpen,
  setIsOpen,
  handleClose,
}) => {
  const { t } = useTranslation();
  const formikRef = useRef();

  const onDialogClose = () => {
    handleClose(formikRef.current?.values);
  };

  return (
    <Dialog
      className={cn('rounded-4 overflow-hidden', styles.dataFieldsDialog)}
      visible={isOpen}
      onHide={() => setIsOpen(false)}
      header={<h3>{t('invoice_statement.customize_data_fields')}</h3>}
      footer={
        <div className="d-flex align-items-center justify-content-end gap-3 mt-3">
          <Button
            outlined
            onClick={() => setIsOpen(false)}
            type="button"
            className="px-5"
            size="medium"
            label={t('common.cancel')}
          />
          <Button
            onClick={onDialogClose}
            type="button"
            className="px-5"
            size="medium"
            label={t('common.confirm')}
          />
        </div>
      }
    >
      <Formik
        validateOnMount
        enableReinitialize
        innerRef={formikRef}
        initialValues={initialValues ?? dataFieldsinitialValues}
      >
        {({ values, errors, touched }) => {
          return (
            <Form className="row">
              {dataFieldFormConfig({ t }).map((section) => (
                <div
                  className={cn(styles.statementForm, 'col')}
                  key={section.id}
                >
                  {section.fields
                    .filter((item) => !item.hide)
                    .map((field) => (
                      <div className="mb-3" key={field.name}>
                        <label
                          className={cn('mb-2', styles.label)}
                          htmlFor={field.name}
                        >
                          {field.label}
                        </label>
                        <FormikField
                          name={field.name}
                          component={field.component}
                          error={errors[field.name]}
                          componentProps={{
                            ...field.componentProps,
                            className: cn(
                              field.componentProps?.className,
                              !values[field.name] ? styles.emptyField : '',
                              errors[field.name] && touched[field.name]
                                ? styles.errorField
                                : '',
                            ),
                          }}
                        />
                      </div>
                    ))}
                </div>
              ))}
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default React.memo(DataFieldsDialog);
